export const agendaData = [
  {
    day: "Wednesday, September 10, 2025",
    sessions: [
      {
        title: "Main Conference Day",
        items: [
          {
            time: "09:30 – 10:00",
            description: "Registration & Welcome Coffee",
            details: [
              "Participants arrive, complete registration, and enjoy a welcome coffee while networking with fellow delegates, speakers, and panelists.",
            ],
          },
          {
            time: "10:00 – 11:15",
            description: "Opening Session & Panel I",
            openingSession: [
              "Opening Remarks: Besnik Tahiri, Founder & President, International Governance Conference",
              "Keynote Address: H.E. Edi Rama, Prime Minister of Albania",
            ],
            panelTitle:
              "Panel I: Governance Challenges and Opportunities in a Rapidly Evolving World",
            details: [
              "This panel sets the stage for the conference by exploring the current landscape of global governance. Panellists will discuss the shifting geopolitical order, the impact of emerging technologies, climate imperatives, and the need for inclusive and resilient governance models. They will reflect on both the challenges faced by policymakers and the opportunities for reform that can shape a more adaptive and forward-looking governance framework.",
            ],
            panelists: [
              "Mayor Harry Hardman – The Bush School of Government and Public Service, Advisory Board Member",
              "Nicholas Abbott – British Ambassador to Albania",
              "Massimiliano Paolucci – World Bank Group Country Manager for Albania",
            ],
            moderator:
              "Modesta Imeri – CEO of Blue Dot Consulting, University of Pennsylvania Alumna",
          },
          {
            time: "11:15 – 11:30",
            description: "Coffee Break",
          },
          {
            time: "11:30 – 13:00",
            description:
              "Panel II: Is the EU Integration Agenda the Only Hope for Western Balkan Countries?",
            details: [
              "The Western Balkans continue to look toward the European Union as a model of political stability, economic growth, and democratic governance. This panel will debate whether EU integration remains the primary pathway for regional prosperity or if alternative multilateral and bilateral frameworks could complement or challenge this trajectory. Speakers will assess the political commitments, reforms, and challenges shaping the integration agenda.",
            ],
            panelists: [
              "Silvio Gonzato – EU Ambassador and Head of Delegation of the European Union to Albania (TBC)",
              "Arben Fetai – Deputy Prime Minister of North Macedonia",
              "Ranko Krivokapić – Former Minister of Foreign Affairs of Montenegro, six times President of Montenegro Parliament",
            ],
            moderator:
              "Jeta Loshaj – Senior Researcher at KCSS, MSc in Russian & East European Studies from Indiana University",
          },
          {
            time: "13:00 – 14:00",
            description: "Networking Lunch",
          },
          {
            time: "14:00 – 15:15",
            description:
              "Panel III: The Case of Albania – Public Sector Reform in the Next Four Years",
            details: [
              "This session will focus on Albania's roadmap for modernizing its public administration and strengthening anti-corruption measures over the next four years. Panelists will examine the implementation of digital governance tools, transparency initiatives, and fiscal accountability reforms, offering both national and international perspectives on best practices to create a more efficient and citizen-oriented public sector.",
            ],
            panelists: [
              "Adea Pirdeni – Minister of State for Public Administration and Anti-Corruption",
              "Tibor Draskovics – Public Policy and Governance Expert; Former Minister of Finance, Justice and Law Enforcement, Hungary",
              "Dimitrie Vasile – Senior Government Specialist, World Bank",
              "Besnik Tahiri – President, International Governance Institute (panelists and moderator)",
            ],
          },
          {
            time: "15:15 – 15:30",
            description: "Coffee Break",
          },
          {
            time: "15:30 – 16:45",
            description:
              "Panel IV: Local Government and Decentralisation Reforms – Why We Need to Rethink This Sector Now",
            details: [
              "Decentralization has long been a key pillar of governance reform, yet its implementation often faces challenges related to capacity, funding, and accountability. This panel will assess the current state of local government in Albania and the wider region, discussing why a fresh approach is needed to empower municipalities, improve service delivery, and foster local economic development.",
            ],
            panelists: [
              "Arbjan Mazniku – Minister of Local Government, Albania",
              "Genc Nimanbegu – Mayor of Ulcinj",
              "Anuela Ristani, Acting Mayor of Tirana, Albania",
              "Norbert A. E. M. Pijls – Director, Bashki të Fortë Project, Helvetas Albania",
              "Valmir Gashi – Executive Director, Kosovo Local Government Institute",
              "Simon O'Meally - Senior Public Sector Economist, The World Bank",
            ],
            moderator:
              "Mark Baskin – Senior Adviser on the Balkans, Center for Humanitarian Dialogue",
          },
          {
            time: "17:00 – 17:45",
            description: "Press Conference: Key Findings & Insights",
            details: [
              "A press briefing summarizing the main conclusions, policy recommendations, and strategic takeaways from the day's discussions.",
            ],
          },
        ],
      },
    ],
  },
];
